import React from 'react';
import Reflux from 'reflux';
import SearchStore from '../stores/SearchStore';
import SuggestedUserItem from '../sections/SuggestedUserItem';

export default class SuggestedUsers extends Reflux.Component {
    constructor () {
        super();
        this.store = SearchStore;
    }

    render () {
        return (
          <div className='suggest-users'>
            <h4 className='title-home size-secondary-title'>
              <span>Personas de interés</span>
            </h4>
            <div className='box-filter'>
              { this.state.suggestedUsers &&
                this.state.suggestedUsers.map((user) => {
                    return (
                      <SuggestedUserItem user={user} key={user._id} />
                    );
                })
              }
            </div>
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/sections/SuggestedUsers.js